module.exports = __webpack_public_path__ + "static/media/PM148.43bb3fe9.png";